<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
    @keydown.esc="cancel"
    :max-width="$vuetify.breakpoint.smAndDown ? 'none' : '600px'"
    content-class="fullscreen-dialog"
    persistent
  >
    <v-card class="dialog-card">
      <v-toolbar color="primary" dense class="header primaryText--text">
        <v-row>
          <v-col cols="2" align-self="end">
            <v-btn text @click="close(false)">{{ $t("close") }}</v-btn>
          </v-col>

          <v-col cols="8" class="d-flex justify-center align-center">
            <div>
              <v-toolbar-title
                class="header-title1"
                v-if="$appMode == 0 && $store.state.store != null && $store.state.store.info != null"
                >{{ $store.getters.storeName }}</v-toolbar-title
              >
              <v-toolbar-title class="header-title2">{{ $t("member_code") }}</v-toolbar-title>
            </div>
          </v-col>

          <v-col cols="2" align-self="end" style="text-align:right"></v-col>
        </v-row>
      </v-toolbar>

      <v-card-text>
        <barcode class="barcode" v-show="barcode != null" :value="barcode"></barcode>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import VueBarcode from "vue-barcode";

export default {
  components: {
    barcode: VueBarcode,
  },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,

    barcode: "",
  }),

  methods: {
    open(barcode) {
      console.log("Barcode Page opening");

      this.barcode = barcode;

      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close(result) {
      this.dialog = false;
      this.resolve(result);
    },
  },
};
</script>

<style lang="scss" scoped>
.barcode {
  width: 100%;
  text-align: center;
  margin-top: 50px;
}
</style>
